import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';
import {ClientMelding, ClientMeldingDto} from './client-melding';

@Injectable({
  providedIn: 'root'
})
export class ClientMeldingService {
  private http = inject(HttpClient);

  getClientMeldingen$(clientId: string): Observable<Array<ClientMelding>> {
    const params = new HttpParams()
      .set('clientId', clientId);
    return this.http.get<Array<ClientMeldingDto>>(`${environment.apiUrl}/clientmeldingen`, {params})
      .pipe(map(dtos => dtos.map(dto => ClientMelding.deserialize(dto))));
  }

  postClientMelding$(clientId: string, content: string, dienstId?: string): Observable<ClientMelding> {
    return this.http.post<ClientMeldingDto>(`${environment.apiUrl}/clientmeldingen`, {clientId, content, dienstId})
      .pipe(map(dto => ClientMelding.deserialize(dto)));
  }

  putClientMelding$(id: string, content: string, dienstId?: string): Observable<ClientMelding> {
    return this.http.put<ClientMeldingDto>(`${environment.apiUrl}/clientmeldingen/${id}`, {content, dienstId})
      .pipe(map(dto => ClientMelding.deserialize(dto)));
  }

  deleteClientMelding$(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/clientmeldingen/${id}`);
  }
}
